import React, { useEffect, useState } from 'react'
import classes from './CreateFantasyTeam.module.css'
import Layout from '../component/Layout'
import SubLayout from '../component/SubLayout'
import Header from '../component/Header'
import { useLocation, useNavigate } from 'react-router-dom'
import { fetchUpcomingMatchDetailsApi, userFantasyTeamApi } from '../http/http'
import { useDispatch, useSelector } from 'react-redux'
import { FaArrowLeft, FaMinus, FaPlus, FaXmark } from "react-icons/fa6";
import moment from 'moment-timezone'
import { toast } from 'react-toastify'
import SmallLoader from '../component/SmallLoader'
import { removeUserDetails } from '../store/slices/userSlice'
import { useTranslation } from 'react-i18next'

const CreateFantasyTeam = () => {
    const location = useLocation();
    const [matchDetails, setMatchDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { userDetails } = useSelector((state) => state.persisted.userSlice);
    const [position, setPosition] = useState("goalkeepers");
    const [players, setPlayers] = useState(null);
    const [selectedPlayers, setSelectedPlayers] = useState([]);
    const [loader, setLoader] = useState(true);
    const [time, setTime] = useState(null);
    const [playModal, setPlayModal] = useState(false);

    const {t}=useTranslation();

    const dispatch = useDispatch();

    const matchTimer = (match_date_time) => {
        try {
            const liveTime = moment();
            const matchTime = moment.utc(match_date_time);
            const timeLeft = moment.duration(matchTime.diff(liveTime));

            if (timeLeft.asMilliseconds() <= 0) {
                console.log("Match has already started.");
                navigate("/home");
                toast.info(t("18"));
            }
            const hours = Math.floor(timeLeft.asHours());
            const minutes = timeLeft.minutes();
            const seconds = timeLeft.seconds();

            console.log(`Match starts in ${hours}h ${minutes}m ${seconds}s`);
            // return `${hours}h ${minutes}m ${seconds}s`;
            setTime(`${hours}h ${minutes}m ${seconds}s`)
            // setExpireTime(`${hours}h ${minutes}m ${seconds}s`)
        } catch (error) {
            console.log(error, 'errro--');
        }
    }

    useEffect(() => {
        if (matchDetails) {
            const intervalId = setInterval(() => {
                matchTimer(matchDetails?.match_date_time);
            }, 1000);

            return () => {
                clearInterval(intervalId);
            }
        }
    }, [matchDetails]);

    const fetchMatchDetails = async (match_fixture_id, load) => {
        try {
            if (load) {
                setLoading(true);
            }
            setLoader(true);
            const response = await fetchUpcomingMatchDetailsApi(match_fixture_id, userDetails?.token);
            console.log(response, 'match details response');
            setMatchDetails(response?.data);
            setPlayers(() => {
                return {
                    homeTeam: JSON.parse(response?.data?.home_team_players),
                    awayTeam: JSON.parse(response?.data?.away_team_players)
                }
            });
            setLoading(false);
            setLoader(false);

        }
        catch (error) {
            if (error?.response?.status == 403) {
                dispatch(removeUserDetails());
                toast.error(t("129"));
                navigate('/');
            }
            else {
                setLoading(false);
                setLoader(false);
                toast.error(error?.response?.data?.message || error?.response?.message || error?.data?.message || t("128"));
            }
        }
    }

    const fetchUserTeam = async (match_fixture_id) => {
        try {

            setLoading(true);
            const response = await userFantasyTeamApi(match_fixture_id, userDetails?.token);
            console.log(response, 'user team,');

            setSelectedPlayers(JSON.parse(response?.data?.team));

            setLoading(false);

        } catch (error) {
            setLoading(false);

            console.log(error, 'error===');
        }
    }

    useEffect(() => {
        if (location?.state?.match_fixture_id) {
            fetchMatchDetails(location?.state?.match_fixture_id, true);
            if (location?.state?.edit) {
                // fetch user team----
                fetchUserTeam(location?.state?.match_fixture_id);
            }
        }
        else {
            navigate("/home");
        }
    }, [location?.state?.match_fixture_id]);

    useEffect(() => {
        if (!loader && location?.state?.match_fixture_id) {
            const intervalId = setInterval(() => {
                if (!document.hidden) {
                    fetchMatchDetails(location?.state?.match_fixture_id, false);
                }
            }, 10000);
            return () => clearInterval(intervalId);
        }

    }, [loader, location?.state?.match_fixture_id]);

    const handleSelectPlayer = async (item, teamId, teamName) => {
        try {
            let count = selectedPlayers.filter(data => data.position == item.position).length;
            let max = item?.position == "Goalkeeper" ? 1 : item?.position == "Defender" ? 4 : item?.position == "Midfielder" ? 4 : 2;
            if (selectedPlayers.find((data) => data.id === item.id)) {
                setSelectedPlayers((prevValue) =>
                    prevValue.filter((data) => data.id !== item.id)
                );
            }
            else if (count >= max) {
                console.log("you can only select playes", max);
                // alert("max limit reached...");
                toast.info(t("19") + " " + max + " " + item?.position);
            }
            else {
                setSelectedPlayers((prevValue) => [
                    ...prevValue,
                    { ...item, teamId, teamName, captain: false, viceCaptain: false },
                ]);
            }
        } catch (error) {
            console.log(error, 'error...');
        }
    }

    console.log(selectedPlayers, 'Players...');

    return (
        <Layout>
            <SubLayout>
                {loading ?
                    <SmallLoader style={{ minHeight: "80dvh", display: "flex", justifyContent: "center", alignItems: "center" }} />
                    : (
                        <>
                            <div className={classes.header}>
                                <div className={classes.header_nav}>
                                    <div className={classes.header_nav_container}>
                                        <button type='button' className={classes.back_button}>
                                            <FaArrowLeft className={classes.back_icon} onClick={() => navigate("/home")} />
                                        </button>
                                        <div className={classes.header_text_container}>
                                            <p className={classes.header_text}>{location?.state?.edit ? t("20") : t("21")} {t("22")}</p>
                                            <p className={classes.header_timer}>{time} {t("23")}</p>
                                        </div>

                                    </div>
                                    <button type='button' className={classes.header_button}
                                    onClick={()=>setPlayModal(true)}
                                    >
                                        {t("24")}
                                    </button>

                                </div>

                                <div className={classes.match_details_container}>
                                    <div className={classes.match_details}>
                                        <div className={classes.team}>
                                            <img src={matchDetails?.home_team_image} alt={matchDetails?.home_team_name} className={classes.team_logo} />
                                            <p className={classes.team_name}>{matchDetails?.home_team_name}</p>
                                            <p className={classes.player_count}>
                                                {selectedPlayers?.filter((data) => data?.teamId == matchDetails?.home_team_id).length}
                                            </p>
                                        </div>
                                        <div className={classes.divider_container}>
                                            <FaMinus className={classes.divider} />
                                        </div>
                                        <div className={classes.team}>
                                            <p className={classes.player_count}>
                                                {selectedPlayers?.filter((data) => data?.teamId == matchDetails?.away_team_id).length}
                                            </p>
                                            <p className={classes.team_name}>{matchDetails?.away_team_name}</p>
                                            <img src={matchDetails?.away_team_image} alt={matchDetails?.away_team_name} className={classes.team_logo} />
                                        </div>
                                    </div>
                                </div>

                                <div className={classes.info}>
                                    <p className={classes.info_text}>{t("25")}</p>
                                </div>

                                <div className={classes.tabs_container}>
                                    <button type='button' className={`${classes.tab_option} ${position === "goalkeepers" && classes.active}`}
                                        onClick={() => setPosition("goalkeepers")}
                                    >
                                        {t("26")} {selectedPlayers.filter((data) => data?.position == "Goalkeeper").length > 0 && `(${selectedPlayers.filter((data) => data?.position == "Goalkeeper").length})`}
                                    </button>
                                    <button type="button" className={`${classes.tab_option} ${position === "defenders" && classes.active}`}
                                        onClick={() => setPosition("defenders")}

                                    >
                                        {t("27")}  {selectedPlayers.filter((data) => data?.position == "Defender").length > 0 && `(${selectedPlayers.filter((data) => data?.position == "Defender").length})`}
                                    </button>
                                    <button type="button" className={`${classes.tab_option} ${position === "midfielders" && classes.active}`}
                                        onClick={() => setPosition("midfielders")}

                                    >
                                        {t("28")} {selectedPlayers.filter((data) => data?.position == "Midfielder").length > 0 && `(${selectedPlayers.filter((data) => data?.position == "Midfielder").length})`}
                                    </button>
                                    <button type="button" className={`${classes.tab_option} ${position === "attackers" && classes.active}`}
                                        onClick={() => setPosition("attackers")}

                                    >
                                        {t("29")} {selectedPlayers.filter((data) => data?.position == "Attacker").length > 0 && `(${selectedPlayers.filter((data) => data?.position == "Attacker").length})`}
                                    </button>
                                </div>

                                <div className={classes.tab_info}>
                                    <p className={classes.tab_info_text}>
                                        {position === "goalkeepers" ?
                                            t("30") : position === "defenders" ? t("31") : position === "midfielders" ? t("32") : t("33")
                                        }
                                    </p>
                                </div>
                            </div>
                            <div className={classes.players_list}>
                                {players?.homeTeam?.[position]?.map((item, index) => {
                                    let selected = selectedPlayers.find((data) => data.id === item.id);
                                    return (
                                        <button className={`${classes.player_container} ${selected && classes.selected}`} type='button' key={index}
                                            onClick={() => handleSelectPlayer(item, players?.homeTeam?.teamId, players?.homeTeam?.teamName)}
                                        >
                                            <div className={classes.player_details}>
                                                <div className={classes.player_image_container}>
                                                    <img src={item?.photo} alt={item?.name} className={classes.player_image} />
                                                </div>
                                                <div className={classes.player_details_container}>
                                                    <p className={classes.player_name}>{item?.name}</p>
                                                    <p className={classes.player_team_name}>{players?.homeTeam?.teamName}</p>
                                                </div>
                                            </div>

                                            {selected ? (
                                                <div className={classes.action_button_minus}>
                                                    <FaMinus className={classes.action_icon_minus} />
                                                </div>
                                            ) : (
                                                <div className={classes.action_button}>

                                                    <FaPlus className={classes.action_icon} />
                                                </div>

                                            )}
                                        </button>
                                    )
                                })}

                                {players?.awayTeam?.[position]?.map((item, index) => {
                                    let selected = selectedPlayers.find((data) => data.id === item.id);
                                    return (
                                        <button className={`${classes.player_container} ${selected && classes.selected}`} type='button' key={index}
                                            onClick={() => handleSelectPlayer(item, players?.awayTeam?.teamId, players?.awayTeam?.teamName)}
                                        >
                                            <div className={classes.player_details}>
                                                <div className={classes.player_image_container}>
                                                    <img src={item?.photo} alt={item?.name} className={classes.player_image} />
                                                </div>
                                                <div className={classes.player_details_container}>
                                                    <p className={classes.player_name}>{item?.name}</p>
                                                    <p className={classes.player_team_name}>{players?.awayTeam?.teamName}</p>
                                                </div>
                                            </div>

                                            {selected ? (
                                                <div className={classes.action_button_minus}>
                                                    <FaMinus className={classes.action_icon_minus} />
                                                </div>
                                            ) : (
                                                <div className={classes.action_button}>

                                                    <FaPlus className={classes.action_icon} />
                                                </div>

                                            )}
                                        </button>
                                    )
                                })}
                            </div>

                            <button type='button' className={`${classes.next_button} ${selectedPlayers.length >= 11 && classes.active}`}
                                disabled={selectedPlayers.length < 11}
                                onClick={() => {
                                    if (selectedPlayers.length >= 11) {
                                        navigate("/select-captains", {
                                            state: {
                                                selectedPlayers,
                                                matchDetails,
                                                edit: location?.state?.edit
                                            }
                                        })
                                    }
                                }}
                            >
                                {t("34")}
                            </button>
                        </>

                    )}
            </SubLayout>


            {playModal &&
                <div className={classes.container2} onClick={() => setPlayModal(false)}>
                    <div className={classes.sub_container2} onClick={(e) => e.stopPropagation()}>
                        <div className={classes.close_btn_container2}>
                            <button type="button" className={classes.close_btn2} onClick={() => setPlayModal(false)}>
                                <FaXmark className={classes.close_icon2} />
                            </button>
                        </div>

                        <div className={classes.msg2}>
                            <h2 className={classes.text2}>
                                {t("35")}
                            </h2>

                            <ul className={classes.paragraph2}>
                                <li>
                                {t("36")}
                                </li>
                                <li>
                                {t("37")}
                                </li>
                                <li>
                                {t("38")}
                                </li>
                                <li>
                            {t("39")}
                                </li>
                                <li>
                                {t("40")}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            }
        </Layout>
    )
}

export default CreateFantasyTeam